import { Link, useLocation } from 'react-router-dom'

function Nav() {
  const location = useLocation()
  const isHome = location.pathname === '/'

  return (
    <nav className="sticky top-0 z-40 backdrop-blur-md bg-[#FAFAF7]/80 border-b border-[#E5E5E5]/60">
      <div className="max-w-6xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-baseline gap-2 group">
          <span className="font-display text-xl font-semibold tracking-tight group-hover:text-[#0F766E] transition-colors">
            Triangle Project Consultants
          </span>
          <span className="font-mono text-[10px] text-[#0A0A0A]/40 hidden sm:inline">/ AI Readiness</span>
        </Link>

        <div className="flex items-center gap-5">
          {!isHome && (
            <Link
              to="/"
              className="font-mono text-xs uppercase tracking-widest text-[#0A0A0A]/60 hover:text-[#0F766E] transition-colors"
            >
              ← Home
            </Link>
          )}
          <a
            href="https://www.triangleprojectconsultants.com"
            target="_blank"
            rel="noopener noreferrer"
            className="font-mono text-xs uppercase tracking-widest text-[#0A0A0A]/60 hover:text-[#0F766E] transition-colors hidden sm:inline"
          >
            Main Site ↗
          </a>
        </div>
      </div>
    </nav>
  )
}

export default Nav
